import { Component, Input } from '@angular/core';

export interface ColumnConfig {
  name: string;
  type: string;
  config?: any;
}

export interface DataTableConfig {
  delimiter?: string;
  columns: ColumnConfig[];
}

export interface ColumnData {
  type: string;
  row: number;
  column: number;
  value: string;
  config: any;
}

export function itemToColumnData(item: { [key: string]: string}, configuration: DataTableConfig, row?: number): ColumnData[] {
  const result = [];
  for (let i = 0; i < configuration.columns.length; i++) {
    const column = configuration.columns[i];
    result.push({
      row: row,
      column: i + 1,
      type: column.type,
      value: item[column.name],
      config: column.config
    });
  }
  return result;
}

@Component({
  selector: 'data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent {

  @Input() columnsData: ColumnData[];
  @Input() configuration: DataTableConfig;
  @Input() translationPrefix: string;
}
